<div class="tab-pane folay-horizontal-desktop show active pt-4 pt-md-0" *transloco="let t;">
	<div class="folay-top d-table px-3 px-md-4 text-center mt-2 mt-md-0">
		<div class="topbar">
			<div class="topbar-left-action text-dark">
				<ion-icon name="chevron-back" class="f24" (click)="back();" />
			</div>
		</div>

		<div class="folay-title d-table-row f24">
			<img class="mb-4" src="/assets/images/icon/upstation-black.svg" alt="UP Station Logo" loading="lazy">
			
			<div class="fsemibold">{{ t('modal.auth.create_account') }}</div>
			<div class="folay-subtitle">{{ t('modal.auth.get_updates') }}</div>
		</div>
	</div>

	<div class="folay-dark-container mt-3 mt-md-0">
		@if (isRegister) {
			<form [formGroup]="form">
				<div class="form-group input-underline">
					<label class="text-white">{{ t('form.' + form.value.strategy) }}</label>

					<div class="d-flex align-items-center">
						<input class="flex-shrink-0 cc-input d-none mr-2 form-control" [class.d-block]="form.value.strategy === 'mobileNumber'" type="text" value="(+{{ form.value.phoneCode }})" readonly />
						<ups-input class="flex-grow-1 my-0" [formControl]="form.controls[form.value.strategy!]" type="text" (input)="format();" />
					</div>
				</div>

				<ups-input formControlName="name" type="text" autocomplete="name" label="{{ t('form.name') }}" [required]="true" />
                <ups-select formControlName="gender" label="{{ t('form.gender') }}" placeholder="{{ t('form.gender') }}" [options]="genderOpt" />
				<ups-date id="su-birth" formControlName="dob" label="{{ t('form.birthday') }}" />

				<ups-password formControlName="password" class="mb-1" [showStrength]="true" />
				<ups-password formControlName="confirm" label="{{ t('form.repeat_new_password') }}" [mustSame]="true" />

				<button class="btn btn-thumb btn-primary btn-block mt-4 fsemibold" [disabled]="form.invalid" (click)="register();" #btn>{{ t('button.auth.register') }}</button>
			</form>
		} @else {
			<button class="d-flex btn-thumb align-items-center btn login-btn rounded btn-apple btn-block mt-3 fsemibold" (click)="setStrategy('email');">
                <img class="mr-2" src="/assets/images/navigation/homepage/cs-email-w.svg" alt="{{ t('form.email') }}" loading="lazy">
                <div class="w-100">{{ t('button.auth.email_register') }}</div>
            </button>

            <button class="d-flex btn-thumb align-items-center btn login-btn rounded btn-apple btn-block mt-3 fsemibold" (click)="setStrategy('mobileNumber');">
                <img class="mr-2" src="/assets/images/navigation/homepage/phone.svg" alt="{{ t('form.mobileNumber') }}" loading="lazy">
                <div class="w-100">{{ t('button.auth.phone_register') }}</div>
            </button>

            <div class="text-center u-body-3 text-white mt-3">
                {{ t('modal.auth.have_account') }} <a type="button" class="u-body-3 text-primary" (click)="back();">{{ t('button.auth.signin') }}</a>
            </div>

            <div class="text-center u-body-3 text-white mt-3">
                {{ t('modal.auth.agreement') }} <a type="button" class="u-body-3 text-primary text-decoration-none" href="/copyright-disclaimer" target="_blank">{{ t('modal.auth.our_tnc') }}</a>.
            </div>
		}
	</div>
</div>
